import axios from 'axios';
import { editRecurringAssignmentQuery } from './queries';

const editRecurringAssignment = (model, key) =>
    new Promise((resolve, reject) => {
        const query = editRecurringAssignmentQuery({ model, key });
        const request = axios.put(query.url, { ...query.body });
        request
            .then((response) => {
                resolve({ data: response.data });
            })
            .catch((errors) => {
                // eslint-disable-next-line no-console
                console.log(errors);
                reject(new Error('Unable to edit Assignment'));
            });
    });

export default editRecurringAssignment;
